import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGroups} from '../store/thunk/setGroups';
import {setUsers} from '../store/thunk/setUsers';
import Dialog from '@material-ui/core/Dialog';
import {setCreateUser} from '../store/thunk/setCreateUser';
import {setCreateGroup} from '../store/thunk/setCreateGroup';
import {setChangePassword} from '../store/thunk/setChangePassword';
import {useStyles} from './helpers';
import Title from '../../../../@casino/ui/title';
import { setPostChangeLetter } from '../store/thunk/setPostChangeLetter';
import { setPostBlock } from '../store/thunk/setPostBlock';
import {ReactComponent as Eye} from '../../../../@casino/img/eye.svg';
import { setPostHide } from '../store/thunk/setPostHide';
import { setPostWager } from '../store/thunk/setPostWager';

const Cashiers = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGroups({
            group: '',
            hide: false
        }));
    }, []);

    const groups = useSelector(state => state.cashier.groups);
    const [selectedGroup, setSelectedGroup] = React.useState('');
    
    React.useEffect(() => {
        if (groups && groups.length) {
            dispatch(setUsers({
                groups: groups[0].groups,
                cashier: '',
                hide: false
            }));
            setSelectedGroup(groups[0].groups);
        }
    }, [groups])

    const users = useSelector(state => state.cashier.users);
    const [openModalGroup, setOpenModalGroup] = React.useState(false);
    const [openModalUser, setOpenModalUser] = React.useState(false);
    const [login, setLogin] = React.useState('');
    const [letter, setLetter] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [newGroup, setNewGroup] = React.useState('');
    const [openModalPassword, setOpenModalPassword] = React.useState(false);
    const [userIdPassword, setUserIdPassword] = React.useState(0);
    const [newPassword, setNewPassword] = React.useState('');
    const [searchCashier, setSearchCashier] = React.useState('');
    const [searchGroup, setSearchGroup] = React.useState('');
    const [isOpenChangeLetter, setIsOpenChangeLetter] = React.useState(false)
    const [isOpenView, setIsOpenView] = React.useState(false);
    const [viewModel, setViewModel] = React.useState({});
    const [tab, setTab] = React.useState('active');
    const [wagerOpen, setWagerOpen] = React.useState(false);
    const [wager, setWager] = React.useState('');
    const [currency, setCurrency] = React.useState('');

    return (
        <>
            <div className={classes.title}>
                <Title label="Кассиры" />
            </div>
            <div style={{
                display: 'flex',
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
                margin: '0 20px',
                justifyContent: 'space-between'
            }}>
                <div>
                    <span 
                        style={{fontSize: 18, textTransform: 'uppercase', marginRight: 12, cursor: 'pointer', fontWeight: tab === 'active' && 700, color: tab === 'active' ? 'rgba(255,195,37)' : '#fff'}}
                        onClick={() => {
                            setTab('active');
                            dispatch(setGroups({
                                group: '',
                                hide: false
                            }));
                        }}    
                    >Активные</span>
                    <span 
                        style={{fontSize: 18, textTransform: 'uppercase', cursor: 'pointer', fontWeight: tab === 'archive' && 700, color: tab === 'archive' ? 'rgba(255,195,37)' : '#fff'}}
                        onClick={() => {
                            setTab('archive');
                            dispatch(setGroups({
                                group: '',
                                hide: true
                            }));
                        }}
                    >Скрытые</span>
                </div>
                <div>
                    <span style={{color: '#fff', cursor: 'pointer'}} onClick={() => setWagerOpen(true)}>WAGER: {groups && groups.length ? groups[0].wager : 0}</span>
                </div>
            </div>
            {
                tab === 'archive' &&
                <div style={{
                    display: 'flex',
                    padding: '20px',
                    background: '#1b2039',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '20px 20px 0'
                }}>
                    <div className={classes.wrapSearch}>
                        <div>
                            <input 
                                type="text" 
                                placeholder="Поиск группы" 
                                value={searchGroup}
                                onChange={(v) => {
                                    setSearchGroup(v.target.value);
                                    dispatch(setGroups({
                                        group: v.target.value
                                    }));
                                }}
                                className={classes.search}/>
                            <div onClick={() => setOpenModalGroup(true)} className={classes.btn}>
                                <span>ДОБАВИТЬ</span>
                            </div>
                        </div>
                        <div className={classes.mt12}>
                            {
                                groups && groups.map((item) => (
                                    <p 
                                        onClick={() => {
                                            dispatch(setUsers({groups: item.groups, cashier: ''})); 
                                            setSelectedGroup(item.groups)
                                        }}
                                        className={classes.group}
                                        style={{display: 'flex', alignItems: 'center'}}
                                    >
                                        {item.id}. {item.groups}
                                        <div>
                                            <Eye 
                                                style={{width: 20, height: 20, fill: '#fff'}}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setIsOpenView(true)
                                                    setViewModel({
                                                        id: item.id,
                                                        hide: item.hide
                                                    })
                                                }}
                                            />
                                        </div>
                                    </p>
                                ))
                            }
                        </div>
                    </div>
                </div>
            }
            {
                tab === 'active' &&
                <div 
                    className={classes.root}
                    >
                    <div className={classes.wrapSearch}>
                        <div>
                            <input 
                                type="text" 
                                placeholder="Поиск группы" 
                                value={searchGroup}
                                onChange={(v) => {
                                    setSearchGroup(v.target.value);
                                    dispatch(setGroups({
                                        group: v.target.value
                                    }));
                                }}
                                className={classes.search}/>
                            <div onClick={() => setOpenModalGroup(true)} className={classes.btn}>
                                <span>ДОБАВИТЬ</span>
                            </div>
                        </div>
                        <div className={classes.mt12}>
                            {
                                groups && groups.map((item) => (
                                    <p 
                                        onClick={() => {
                                            dispatch(setUsers({groups: item.groups, cashier: ''})); 
                                            setSelectedGroup(item.groups)
                                        }}
                                        className={classes.group}
                                        style={{display: 'flex', alignItems: 'center'}}
                                    >
                                        {item.id}. {item.groups}
                                        <div>
                                            <Eye 
                                                style={{width: 20, height: 20, fill: '#fff'}}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setIsOpenView(true)
                                                    setViewModel({
                                                        id: item.id,
                                                        hide: item.hide
                                                    })
                                                }}
                                            />
                                        </div>
                                    </p>
                                ))
                            }
                        </div>
                    </div>
                    <div className={classes.divider}></div>
                    <div className={classes.searchCashier}>
                        <div>
                            <input 
                                type="text" 
                                placeholder="Поиск кассира" 
                                className={classes.search} 
                                value={searchCashier} 
                                onChange={(v) => {
                                    setSearchCashier(v.target.value);
                                    dispatch(setUsers({
                                        groups: groups[0].groups,
                                        cashier: v.target.value
                                    }));

                                }}/>
                            <span onClick={() => setOpenModalUser(true)}  className={classes.btn}>ДОБАВИТЬ</span>
                        </div>
                        <div className={classes.mt12}>
                            {
                                users && users.map((item, key) => (
                                <div  className={classes.group}>
                                    <div>
                                        {item.id}. {item.login} <span style={{textTransform: 'uppercase'}}>({item.letter})</span>
                                    </div>
                                    <div>
                                    <span  className={classes.btn} onClick={() => dispatch(setPostBlock({id: item.id, block: !!!item.block}))} >{item.block ? 'Разблокировать' : 'Заблокировать'}</span>    
                                    <span  className={classes.btn} onClick={() => {setLetter(item.letter); setLogin(item.login); setSelectedGroup(item.groups); setIsOpenChangeLetter(true)}} >Изменить букву</span>
                                    <button onClick={() => {setOpenModalPassword(true); setUserIdPassword(item.id);}} className={classes.btn} style={{outline: 'none', userSelect: 'none'}}>Изменить пароль</button>
                                    </div>
                                
                                </div>
                                )
                                )
                            }
                        </div>
                    </div>
                    <Dialog 
                        onClose={() => {
                            setIsOpenChangeLetter(false);
                            setLogin('');
                            setPassword(''); 
                            setLetter('');
                        }} open={isOpenChangeLetter}>
                        <div style={{width: 300, padding: '10px 20px 20px'}}>
                            <h3 style={{padding: 0, margin: 0, fontSize: 16, textAlign: 'center', color: '#2f2f2f', marginBottom: 12, textTransform: 'uppercase'}}>Изменить букву кассира</h3>
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}> 
                                {/* <input 
                                    type="password" 
                                    placeholder="Пароль" 
                                    onChange={(v) => setPassword(v.target.value)} 
                                    value={password} 
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                        marginBottom: 8
                                    }}
                                /> */}
                                <input 
                                    type="text" 
                                    placeholder="Буква кассира" 
                                    onChange={(v) => setLetter(v.target.value)} 
                                    value={letter}
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                        marginBottom: 8
                                    }}
                                />
                                <span
                                    style={{
                                        background: 'rgba(255,195,37)',
                                        borderRadius: 4,
                                        padding: '5px 10px',
                                        marginTop: 12,
                                        textAlign: 'center',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        dispatch(setPostChangeLetter({letter, login, groups: selectedGroup}));
                                        setIsOpenChangeLetter(false);
                                    }}>
                                    Изменить
                                </span>
                            </div>
                        </div>
                    </Dialog>
                    <Dialog 
                        onClose={() => {
                            setOpenModalUser(false);
                            setLogin('');
                            setPassword(''); 
                            setLetter('');
                        }} open={openModalUser}>
                        <div style={{width: 300, padding: '10px 20px 20px'}}>
                            <h3 style={{padding: 0, margin: 0, fontSize: 16, textAlign: 'center', color: '#2f2f2f', marginBottom: 12, textTransform: 'uppercase'}}>Добавить нового кассира</h3>
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}> 
                                <input 
                                    type="text" 
                                    placeholder="Логин" 
                                    onChange={(v) => setLogin(v.target.value)} 
                                    value={login}
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                        marginBottom: 8
                                    }}
                                />
                                <input 
                                    type="password" 
                                    placeholder="Пароль" 
                                    onChange={(v) => setPassword(v.target.value)} 
                                    value={password} 
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                        marginBottom: 8
                                    }}
                                />
                                <input 
                                    type="text" 
                                    placeholder="Буква кассира" 
                                    onChange={(v) => setLetter(v.target.value)} 
                                    value={letter}
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                        marginBottom: 8
                                    }}
                                />
                                <input 
                                    type="text" 
                                    name="" 
                                    id=""
                                    value={selectedGroup}
                                    disabled
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                    }}
                                />
                                <span
                                    style={{
                                        background: 'rgba(255,195,37)',
                                        borderRadius: 4,
                                        padding: '5px 10px',
                                        marginTop: 12,
                                        textAlign: 'center',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        dispatch(setCreateUser({login, password, groups: selectedGroup, letter}));
                                        
                                        setOpenModalUser(false);
                                    }}>
                                    Добавить
                                </span>
                            </div>
                        </div>
                    </Dialog>
                    <Dialog onClose={() => setOpenModalGroup(false)} open={openModalGroup}>
                        <div style={{width: 300, padding: '10px 20px 20px'}}>
                            <h3 style={{padding: 0, margin: 0, fontSize: 16, textAlign: 'center', color: '#2f2f2f', marginBottom: 12, textTransform: 'uppercase'}}>Добавить новую группу</h3>
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                <input 
                                    type="text" 
                                    placeholder="Новая группа"
                                    onChange={(v) => setNewGroup(v.target.value)} 
                                    value={newGroup}
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                    }}
                                />
                                 <input 
                                    type="text" 
                                    placeholder="WAGER"
                                    onChange={(v) => setWager(v.target.value)} 
                                    value={wager}
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        marginTop: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                    }}
                                />
                                <div style={{marginTop: 12}}>
                                    <label >
                                        <span style={{marginRight: 12}}>Валюта</span>
                                        <select 
                                            value={currency}
                                            onChange={(v) => setCurrency(v.target.value)}
                                            style={{
                                                height: 34,
                                                borderRadius: 4,
                                                outline: 'none',
                                                paddingLeft: 12,
                                                width: 150
                                            }}
                                        >
                                            <option value="" style={{display: 'none'}}>Выбрать валюту</option>
                                            <option value="RUB">RUB</option>
                                            <option value="USD">USD</option>
                                            <option value="EUR">EUR</option>
                                            <option value="GEL">GEL</option>
                                            <option value="TRY">TRY</option>
                                        </select>
                                    </label>
                                </div>
                                <span 
                                    onClick={() => {
                                        dispatch(setCreateGroup({groups: newGroup, currency, wager}))
                                        setOpenModalGroup(false);
                                    }}
                                    style={{
                                        background: 'rgba(255,195,37)',
                                        borderRadius: 4,
                                        padding: '5px 10px',
                                        marginTop: 12,
                                        textAlign: 'center',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    }}
                                >Добавить</span>
                            </div>
                            
                            
                        </div>
                    </Dialog>
                    <Dialog onClose={() => setOpenModalPassword(false)} open={openModalPassword}>
                        <div style={{width: 300, padding: '10px 20px 20px'}}>
                            <h3 style={{padding: 0, margin: 0, fontSize: 16, textAlign: 'center', color: '#2f2f2f', marginBottom: 12, textTransform: 'uppercase'}}>Изменить пароль</h3>
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                <input 
                                    type="text" 
                                    placeholder="Изменить пароль" 
                                    onChange={(v) => setNewPassword(v.target.value)} 
                                    value={newPassword}
                                    style={{
                                        border: '1px solid #ececec',
                                        padding: 10,
                                        borderRadius: 4,
                                        outline: 'none',
                                    }}
                                />
                                <span 
                                    style={{
                                        background: 'rgba(255,195,37)',
                                        borderRadius: 4,
                                        padding: '5px 10px',
                                        marginTop: 12,
                                        textAlign: 'center',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        dispatch(setChangePassword({
                                            newPassword: newPassword,
                                            id: userIdPassword,
                                        }))
                                        
                                        setOpenModalPassword(false);
                                        
                                    }}
                                >Изменить</span>
                            </div>
                        </div>
                    </Dialog>
                </div>
            }
            <Dialog onClose={() => setIsOpenView(false)} open={isOpenView}>
                        <div style={{width: 300, padding: '10px 20px 20px'}}>
                            <h3 style={{padding: 0, margin: 0, marginTop: 12, fontSize: 16, textAlign: 'center', color: '#2f2f2f', marginBottom: 12, textTransform: 'uppercase'}}>Скрыть группу?</h3>
                            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                <span 
                                    style={{
                                        background: 'rgba(255,195,37)',
                                        borderRadius: 4,
                                        padding: '5px 10px',
                                        marginTop: 12,
                                        textAlign: 'center',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        dispatch(setPostHide({id: viewModel.id, hide: !viewModel.hide}))
                                        setIsOpenView(false)

                                    }}
                                >Да</span>
                                <span 
                                    style={{
                                        background: '#eee',
                                        borderRadius: 4,
                                        padding: '5px 10px',
                                        marginTop: 12,
                                        textAlign: 'center',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setIsOpenView(false)
                                    }}
                                >Нет</span>
                            </div>
                        </div>
                    </Dialog>
                    <Dialog onClose={() => setWagerOpen(false)} open={wagerOpen}>
                        <div style={{padding: 20}}>
                            <div style={{marginBottom: 12}}>
                                Выставьте значение WAGER для операторов
                            </div>
                            <input
                                type="text" 
                                name="" 
                                id=""
                                style={{border: '1px solid #eee',borderRadius: 8, padding: 10, width: 'calc(100% - 20px)'}}
                                placeholder="Значение"
                                onChange={(e) => setWager(e.target.value)}
                                value={wager}
                            />
                            <div 
                                style={{marginTop: 12, width: '100%', display: 'flex', cursor: 'pointer'}}
                                onClick={() => {
                                    dispatch(setPostWager({wager}))
                                    setWagerOpen(false);
                                }}
                            >
                                <span style={{width: '100%', padding: 10, background: 'gold', display: 'flex', justifyContent: 'center', borderRadius: 4}}>Выставить</span>
                            </div>
                        </div>
                    </Dialog>
        </>
    )
}

export default Cashiers;